import React from "react";
import { Link } from "react-router-dom";
import "./ApplicationStatus.css";

export function isLearnerApplication(application) {
  const state = String(application?.state || "").trim().toLowerCase();
  const status = String(application?.status || "").trim().toLowerCase();
  return state === "learner" || status === "learner";
}

export default function ApplicationStatus({ application }) {
  const learner = isLearnerApplication(application);

  return (
    <section className="application-status" aria-live="polite">
      <p className="application-status__label">Application status</p>
      <strong>{learner ? "Learner" : "Submitted"}</strong>
      {learner ? (
        <Link className="pa-primary-button" to="/unity/learner">
          <span>Open learner dashboard</span>
          <span aria-hidden="true">›</span>
        </Link>
      ) : (
        <p>Your application has been submitted. Please wait for approval. You cannot open the programme until you are approved.</p>
      )}
    </section>
  );
}
